<template>
<div >
<button type="button" @click="$emit('close')" class="btn btn-secondary mb-1 mr-3">
  <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
  RITORNA A LISTA UTENTI</button> 

  <div class="card card border-info">
  <div class="card-header">
    <i class="fas fa-user-cog mr-2" aria-hidden="true"></i>
    MODIFICA CONFIGURAZIONE MENU UTENTE  - <span class=" badge badge-light mb-2 mt-2">{{ user.userName }}</span>
    <button :disabled="spinner" type="button" @click="updateUserMenu()" class="btn btn-primary mb-1 ml-3">
  <i class="fas fa-edit mr-2" aria-hidden="true"></i>
  SALVA CONFIGURAZIONE
<span v-if="spinner"  class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
</button>   
<alert-box class="mt-2 mb-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

  </div>  

  <div class="card-body">
    

  <tree-item
        class="item ml-3"
        :item="treeData"
       
      ></tree-item>
  </div>
  </div>    
</div> 

</template>

<script>


import api                from "@/api"
import TreeItem           from '@/components/admin/TreeItem.vue';
import alertBox           from '@/components/common/AlertBox.vue'
export default {
   props : ['user'],
   components: {TreeItem,alertBox},  
  

  data () {
    return {      
      
      treeData : {},
      userMenu : [],
      msg          : {
       title       : ''
      },
     
    
      spinner         : false

    }
  },
  computed: 
  {   
  },
   
  mounted()
    { 
      
    },
  created()
  {
    this.getData()
  },
  methods: 
  {
    setMenuTree()
    {
      

      let index = 0
      const menuData = {name:'Configurazione Menu ',children:[],menuTitle:1}
      
      let obj     = {name : 'BACK OFFICE',children:[],isOpen:0}
      menuData.children.push(obj)
      let arrLength = menuData.children.length
      let arrData = this.$router.options.routes.filter(item => item.meta.menu.indexOf('bo') != -1)  
            
      arrData.forEach(item =>{        
        menuData.children[arrLength-1].children.push({component : item.name, name : item.meta.name ,selected : false,menuIndex : index++})                      
      })

      
      obj     = {name : 'FRONT OFFICE',children:[],isOpen:0}
      menuData.children.push(obj)
      arrLength = menuData.children.length

      arrData = this.$router.options.routes.filter(item => item.meta.menu.indexOf('fo') != -1)  
      arrData.forEach(item =>{
        menuData.children[arrLength-1].children.push({component : item.name, name : item.meta.name ,selected : false,menuIndex : index++})                      
      })

      obj     = {name : 'REPORT',children:[],isOpen:0}
      menuData.children.push(obj)
      arrLength = menuData.children.length

      arrData = this.$router.options.routes.filter(item => item.meta.menu.indexOf('rp') != -1 )  
      arrData.forEach(item =>{
        menuData.children[arrLength-1].children.push({component : item.name, name : item.meta.name ,selected : false,menuIndex : index++})                      
      })

      obj     = {name : 'ADMIN',children:[],isOpen:0}
      menuData.children.push(obj)
      arrLength = menuData.children.length      
      arrData = this.$router.options.routes.filter(item => item.meta.menu.indexOf('ad') != -1)    
      
      arrData.forEach(item => {      
        menuData.children[arrLength-1].children.push({component : item.name, name : item.meta.name ,selected : false,menuIndex : index++})                      
      })
      
      this.treeData = menuData
                  
    },
          toggle: function() {
            if (this.isFolder) {
              this.isOpen = !this.isOpen;
            }
          },
         
    
          
    async  getData()
    {
      var sp    = {'sp':'spUserMenu'}
      var data  = {'userId' : this.user.userId}
     
      var json  = Object.assign(data, sp);
      
      await api.post(json).then(res => {
        if(res.status==200)
          {
            //this.treeData = {name: "Menu utente"}
            //this.treeData 
            let userMenu = res.data.recordsets[0]   
            
            this.setMenuTree()    

            this.treeData.children.forEach(item=>{
                item.children.forEach(child => {
               
                const component = child.component
                userMenu.forEach(userMenu => {
               
                  if(userMenu.component == component)
                  {
                    child.selected = true
                  }
                  
                 
                  
                })

              })
            })  
            
                  
          }
          else if(res.status==500)
          {
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res.data
            this.msg.type = 1

          } 
          else
          {
            this.msg.title = 'ATTENZIONE '                       
            this.msg.body = res
            this.msg.type = 1                
          } 
      }).catch(err => 
      {
      
        this.msg.title = 'ATTENZIONE '
        this.msg.body = err.message
        this.msg.type = 1           
      }).finally(() => {
        //this.spinner = false
      });

    },
    async  updateUserMenu()
    {
      this.msg.title = ''
      this.spinner = true
      let body = []
      this.treeData.children.forEach(item=>{
        item.children.forEach(child=>{
          if(child.selected)
          {
            body.push({'component' : child.component
              })
          }
        })
      })  
      
      const sp    = {'sp':'spUpdateUserMenu'}
      const data  = {'userId' : this.user.userId,'body' : body}
  
      const json  = Object.assign(data, sp);
      
      await api.post(json).then(res => {
        if(res.status==200)
          {
            this.msg.title = 'MODIFICA MENU UTENTE EFFETTUATA.'
            this.msg.body = ''
            this.msg.type = 0
                  
          }
          else if(res.status==500)
          {
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res.data
            this.msg.type = 1

          } 
          else
          {
            this.msg.title = 'ATTENZIONE '                       
            this.msg.body = res
            this.msg.type = 1                
          } 
      }).catch(err => 
      {
      
        this.msg.title = 'ATTENZIONE '
        this.msg.body = err.message
        this.msg.type = 1           
      }).finally(() => {
        this.spinner = false
      });

    },
   
  
  }
    
    
  
}

</script>

<style scoped>


.item {
  cursor: pointer;
}

.badge
{
  font-size: 25px;
}

</style>